import { render, staticRenderFns } from "./k-period-input.vue?vue&type=template&id=637790c6&"
import script from "./k-period-input.vue?vue&type=script&lang=js&"
export * from "./k-period-input.vue?vue&type=script&lang=js&"
import style0 from "./k-period-input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports